export const timeToMinutes = (hour: string): number => {
    const parts: string[] = hour.split(":");
    const hours: number = Number(parts[0]);
    const minutes: number = Number(parts[1]);

    return hours * 60 + minutes;
};
